import { SetupForm } from "../components/SetupForm.js";

export function SetupPage() {
  return (
    <main data-testid="setup-page" className="min-h-screen">
      <SetupForm />
    </main>
  );
}
